import { Controller } from '@hotwired/stimulus';

import { isIOS } from '@/modules/helper';

export default class extends Controller {
  static outlets = ['modal'];

  connect() {
    if (isIOS()) return;

    window.addEventListener('beforeinstallprompt', this.#storePrompt);
  }

  disconnect() {
    window.removeEventListener('beforeinstallprompt', this.#storePrompt);
  }

  async install() {
    if (isIOS()) return this.modalOutlet.open();

    if (!this.prompt) return console.log('[ServiceWorker] Install Prompt not binded.');

    this.prompt.prompt();

    const { outcome } = await this.prompt.userChoice;

    if (outcome === 'accepted') this.prompt = null;
  }

  #storePrompt = (event) => {
    event.preventDefault();

    this.prompt = event;
  };
}
